import React, { useState } from "react";
import { get, find } from "lodash";
import { Button } from "primereact/button";
import { Tooltip } from "primereact/tooltip";
import { Menubar } from "primereact/menubar";
import { PageRequestError } from "components/PageRequestError";
import { ProgressSpinner } from "primereact/progressspinner";
import { DashboardTitle } from "components/DashboardTitle";
import useApp from "hooks/useApp";
import useAuth from "hooks/useAuth";
import ModulesEditPage from "pages/modules/Edit";
import useViewPage from "hooks/useViewPage";
import AssignMetric from "./AssignMetric";
import AssignedMetrics from "./AssignedMetrics";
import { useTranslation } from "react-i18next";
export const CopyText = ({ text }) => {
  const [isCopied, setIsCopied] = useState(false);
  const copyToClipboard = () => {
    navigator.clipboard.writeText(text).then(
      () => {
        setIsCopied(true);
        setTimeout(() => setIsCopied(false), 3000);
      },
      () => {
        console.error("Failed to copy text");
      }
    );
  };
  return (
    <React.Fragment>
      {text ? (
        <>
          <Tooltip target=".copy-icon" />
          {isCopied ? (
            <i
              className="pi pi-check-circle copy-icon"
              data-pr-tooltip="Copied"
            />
          ) : (
            <i
              className="pi pi-clone cursor-pointer copy-icon"
              data-pr-tooltip="Copy"
              onClick={copyToClipboard}
            />
          )}
        </>
      ) : null}
    </React.Fragment>
  );
};

export const ShowMoreLess = ({ text, maxLength }) => {
  const { t } = useTranslation();
  const [isExpanded, setIsExpanded] = useState(false);
  const toggleExpand = () => {
    setIsExpanded(!isExpanded);
  };
  const displayedText = isExpanded
    ? text
    : text
    ? `${text.slice(0, maxLength)}...`
    : "-";
  return (
    <div>
      <p>{displayedText}</p>
      {text && (
        <a
          href="#"
          style={{
            color: "var(--primary-color)",
          }}
          onClick={toggleExpand}
        >
          {isExpanded ? t("SHOW_LESS") : t("SHOW_MORE")}
        </a>
      )}
    </div>
  );
};

const ModulesViewPage = (props) => {
  const app = useApp();
  const auth = useAuth();
  const { t } = useTranslation();
  const EDIT = t("EDIT");
  const DELETE = t("DELETE");
  const CODE = t("CODE");
  const MODULE_ORDER = t("MODULE_ORDER");
  const FACILITIES = t("FACILITIES");
  const NAME = t("NAME");
  const CONFIGURATION = t("CONFIGURATION");
  const ASSIGN_METRIC = t("ASSIGN_METRIC");
  const DETAILS = t("DETAILS");

  const [updateCounter, setUpdateCounter] = useState(0);
  const pageController = useViewPage(props);
  const { item, pageReady, loading, apiRequestError, deleteItem } =
    pageController;

  function ActionButton(data) {
    const items = [
      {
        label: EDIT,
        command: (event) => {
          app.openPageDialog(
            <ModulesEditPage
              isSubPage
              id={data.id}
              organisations={props.organisations}
            />,
            { closeBtn: true }
          );
        },
        icon: "pi pi-pencil",
      },
      {
        label: DELETE,
        command: (event) => {
          deleteItem(data.id, "modules/delete_module");
        },
        icon: "pi pi-trash",
      },
    ];
    return <Menubar className="p-0 " model={items} />;
  }
  function PageFooter() {
    if (props.showFooter) {
      return <div className="flex justify-content-between"></div>;
    }
  }
  if (loading) {
    return (
      <div className="p-3 text-center">
        <ProgressSpinner style={{ width: "50px", height: "50px" }} />
      </div>
    );
  }
  if (apiRequestError) {
    return <PageRequestError error={apiRequestError} />;
  }
  if (pageReady) {
    const getOrgValue = (item) => {
      let orgName = "-";
      if (item && props.organisations.length > 0) {
        const org = find(
          props.organisations,
          (org) => get(org, "code") === get(item, "org_code")
        );
        orgName = org ? get(org, "name", "-") : "-";
      }
      return orgName;
    };

    return (
      <div className="mx-auto card">
        <i
          className="pi pi-arrow-circle-left cursor-pointer"
          onClick={() => app.navigate(-1)}
          style={{ fontSize: "2rem" }}
        />
        <div className="flex justify-content-between items-center">
          <DashboardTitle
            title={`${item.module_name}` + " " + DETAILS}
            imageSrc={item.icon}
            bgColor={`#${item.color}`}
            color="white"
          />
          {auth.user.roleName === "Super Admin" && ActionButton(item)}
        </div>
        <hr />
        <div className="grid">
          <div className="col comp-grid">
            <div>
              <div className="mb-3 grid justify-content-start">
                <div className="col-12 md:col-4">
                  <div className="flex gap-3 align-items-center p-3 ">
                    <div className="">
                      <div className="text-400 font-medium mb-1">Id</div>
                      <div className="font-bold">{get(item, "id", "-")}</div>
                    </div>
                  </div>
                </div>
                <div className="col-12 md:col-4">
                  <div className="flex gap-3 align-items-center p-3 ">
                    <div className="">
                      <div className="text-400 font-medium mb-1">
                        {FACILITIES}
                      </div>
                      <div className="font-bold">{getOrgValue(item)}</div>
                    </div>
                  </div>
                </div>
                <div className="col-12 md:col-4">
                  <div className="flex gap-3 align-items-center p-3 ">
                    <div className="">
                      <div className="text-400 font-medium mb-1">{CODE}</div>
                      <div className="font-bold">{get(item, "code", "-")}</div>
                    </div>
                  </div>
                </div>
                <div className="col-12 md:col-4">
                  <div className="flex gap-3 align-items-center p-3 ">
                    <div className="">
                      <div className="text-400 font-medium mb-1">{NAME}</div>
                      <div className="font-bold">
                        {get(item, "module_name", "-")}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-12 md:col-4">
                  <div className="flex gap-3 align-items-center p-3 ">
                    <div className="">
                      <div className="text-400 font-medium mb-1">
                        {MODULE_ORDER}
                      </div>
                      <div className="font-bold">
                        {get(item, "module_order", "-")}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-12">
                <div className="flex gap-3 align-items-center p-3 ">
                  <div className="">
                    <div className="flex gap-3">
                      <div className="text-400 font-medium mb-1">
                        {CONFIGURATION}
                      </div>
                      <div className="font-bold">
                        <CopyText text={get(item, "module_config", "-")} />
                      </div>
                    </div>
                    <div className="font-bold">
                      <ShowMoreLess
                        text={get(item, "module_config", "-")}
                        maxLength={150}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="flex justify-content-between">
                <div className="flex justify-content-start align-items-center">
                  <Button
                    label={ASSIGN_METRIC}
                    icon="pi pi-plus"
                    type="button"
                    className="p-button w-full bg-primary ml-2"
                    onClick={() => {
                      app.openPageDialog(
                        <AssignMetric
                          isSubPage
                          id={item.id}
                          selectedOrgCode={get(item, "org_code", "-")}
                          organisations={props.organisations}
                          updateCounter={updateCounter}
                          setUpdateCounter={setUpdateCounter}
                        />,
                        { closeBtn: true }
                      );
                    }}
                  />
                </div>
              </div>
              <div
                className="flex"
                style={{
                  marginTop: 20,
                }}
              >
                <AssignedMetrics
                  recId={get(item, "id")}
                  updateCounter={updateCounter}
                  setUpdateCounter={setUpdateCounter}
                />
              </div>
            </div>
          </div>
        </div>
        <PageFooter />
      </div>
    );
  }
};
const withDefaultProps = (Component) => {
  const WrappedComponent = (props) => {
    const { t } = useTranslation();
    const defaultProps = {
      id: null,
      primaryKey: "id",
      pageName: "modules",
      apiPath: "modules/get_module",
      routeName: "modulesview",
      msgBeforeDelete: t("ARE_YOU_SURE_TO_DELETE_MODULE"),
      msgTitle: t("DELETE_MODULE"),
      msgAfterDelete: t("MODULE_DELETED_SUCCESSFULLY"),
      showHeader: true,
      showFooter: true,
      exportButton: true,
      isSubPage: false,
    };
    return <Component {...defaultProps} {...props} />;
  };

  return WrappedComponent;
};
export default withDefaultProps(ModulesViewPage);
